export const TableBodyClasses = () => {
  return {
    base: {
      common: 'text-sm',
      ios: '',
      material: ``
    }
  };
};